import Vue from 'vue';
import _axios from '@/services/axios';
import { AxiosInstance } from 'axios';

function AxiosPlugin(vue: typeof Vue, options?: any): void {
    vue.prototype.$axios = _axios;
  }
  
  declare module 'vue/types/vue' {
    interface Vue {
      $axios: AxiosInstance;
    }
  }
  
  export default AxiosPlugin;